<p>manage-groups-modal works!</p>
